import { WHITE } from "shared/variables";
import cx from "classnames";
import styles from "./Intro.module.css";

export const Intro = ({ color, title, text }) => (
  <div>
    {title && (
      <h1 className={cx(styles.title, { [styles.inverted]: color === WHITE })}>
        {title}
      </h1>
    )}
    {text && (
      <p className={cx(styles.text, { [styles.inverted]: color === WHITE })}>
        {text}
      </p>
    )}
  </div>
);
